/* ========================================================================= */
/* Site name */
/* ========================================================================= */

let SITE_NAME = {};

/**
 * Set global variable SITE_NAME
 * @param {string} siteName
 */
export const setSiteName = (siteName) => {
    SITE_NAME = siteName;
};

/**
 * Get global variable SITE_NAME
 * @return {string}
 */
export default () => {
    return SITE_NAME;
};
